import PropTypes from 'prop-types'
import React, { Component } from 'react'

import BuyButton from '../buy/dumb/BuyButton'

class PromptModal extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.onEscape = this.onEscape.bind(this)
  }

  onEscape({ keyCode }) {
    if (keyCode === 27) {
      this.props.onClose()
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onEscape)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onEscape)
  }

  onClick(value) {
    this.props.onUpdate(value)
  }

  render() {
    return (
      <div
        className={`the-modal big modal prompt-modal ${
          this.props.display ? 'show' : ''
        }`}
        data-modal="prompt"
      >
        <div className="modal-content x-small" style={this.props.extraStyle}>
          <div className="overflow add-shadow">
            <div className="modal-body" style={this.props.extraCssBody}>
              {this.props.children}
            </div>

            <div className="modal-buttons">
              <BuyButton
                classes={`btn ${
                  this.props.mainBtn === 'yes' ? 'btn-primary' : 'btn-secondary'
                } typing inverted`}
                dataCy={this.props.dataCyYes}
                label={'Sì'}
                update={() => this.onClick(true)}
              />
              <BuyButton
                classes={`btn btn-right ${
                  this.props.mainBtn === 'no' ? 'btn-primary' : 'btn-secondary'
                } typing inverted`}
                dataCy={this.props.dataCyNo}
                label={'No'}
                update={() => this.onClick(false)}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

PromptModal.defaultProps = {
  dataCyNo: '',
  dataCyYes: '',
  extraStyle: {},
  extraCssBody: {},
  mainBtn: 'no',
}

PromptModal.propTypes = {
  children: PropTypes.element.isRequired,
  dataCyNo: PropTypes.string,
  dataCyYes: PropTypes.string,
  display: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  extraStyle: PropTypes.object,
  extraCssBody: PropTypes.object,
  mainBtn: PropTypes.oneOf(['yes', 'no']),
}

export default PromptModal
